import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ONOTYNavigation = _ref => {
  var {
    icon,
    title = "",
    subtitle = "",
    children
  } = _ref;
  return /*#__PURE__*/_jsxs("nav", {
    className: "flex flex-wrap items-end justify-between py-8 max-w-7xl mx-auto px-4",
    "data-theme": "onoty",
    children: [/*#__PURE__*/_jsxs("a", {
      className: "hover:cursor-pointer flex",
      href: process.env.NEXT_PUBLIC_VARIANT ? "/" : "/onoty",
      children: [/*#__PURE__*/_jsx("img", {
        className: "w-40 md:w-auto pr-4 md:pr-8 object-scale-down object-center flex-shrink",
        src: icon == null ? void 0 : icon.filename,
        alt: icon == null ? void 0 : icon.alt
      }), /*#__PURE__*/_jsxs("div", {
        className: "pl-4 md:pl-8",
        children: [title ? /*#__PURE__*/_jsx("h3", {
          className: "max-w-xs text-3xl md:text-4xl font-normal leading-none",
          children: title
        }) : null, subtitle ? /*#__PURE__*/_jsx("h6", {
          className: "mt-2 text-grey font-medium",
          children: subtitle
        }) : null]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "flex gap-4 pt-4 items-center flex-wrap",
      children: children
    })]
  });
};
//# sourceMappingURL=onoty_navigation.js.map